import type { ImageSourcePropType } from 'react-native';
import type { ShareCardArtKey } from '@tabbio/utils/cv-share-card';

/**
 * Rendered theme art for the share card, keyed by the catalog's art keys.
 * `tabbio` is the Figma gradient (share-card-bg.png); the gradient themes
 * come from apps/web/scripts/render-share-themes.mjs. One map feeds the
 * native card, the web card and the editor's theme swatches, so a theme can
 * not render from one file in the preview and another in the picker.
 */
export const SHARE_THEME_ART: Record<ShareCardArtKey, ImageSourcePropType> = {
  tabbio: require('../../../assets/branding/share-card-bg.png'),
  aurora: require('../../../assets/branding/share-themes/aurora.webp'),
  dusk: require('../../../assets/branding/share-themes/dusk.webp'),
  uae: require('../../../assets/branding/share-themes/uae.webp'),
  saudi: require('../../../assets/branding/share-themes/saudi.webp'),
  qatar: require('../../../assets/branding/share-themes/qatar.webp'),
  kuwait: require('../../../assets/branding/share-themes/kuwait.webp'),
  bahrain: require('../../../assets/branding/share-themes/bahrain.webp'),
  oman: require('../../../assets/branding/share-themes/oman.webp'),
};

/**
 * The art as a URL for DOM `url(...)` / `src` use. Metro hands web a string
 * for an asset require; the other shapes are covered so a bundler change
 * cannot silently blank every theme.
 */
export function shareThemeArtUri(key: ShareCardArtKey): string {
  const value: unknown = SHARE_THEME_ART[key];
  if (typeof value === 'string') return value;
  if (value && typeof value === 'object') {
    const record = value as { uri?: unknown; default?: unknown };
    if (typeof record.uri === 'string') return record.uri;
    if (typeof record.default === 'string') return record.default;
  }
  return String(value);
}
